import React from 'react'
import { Field } from 'redux-form'
import interpreting from '../../images/interpreting.svg'
import coaching from '../../images/coaching.svg'
import translation from '../../images/translation.svg'
import official from '../../images/official.svg'
import i18n from '../../translations/i18n';

const DavronFormRequestType = props => {
	let lng = props.lng;
	return (
		<div className="form-section">
			<div className="row services">
				<div className="col-6 col-md-3 form-input">
				<div className="radio-button">
					<Field
						name="service"
						id="translation"
						type="radio"
						component="input"
						value="translation"
						onClick={props.onClick}
					/>
					<label htmlFor="translation" className="davron-label">
					<img src={translation} alt="translation-logo" />
					{i18n.t('services.translation', {lng})}
					</label>
					</div>
				</div>
				<div className="col-6 col-md-3 form-input">
				<div className="radio-button">
					<Field
						name="service"
						id="official"
						type="radio"
						component="input"
						value="official"
						onClick={props.onClick}
					/>
					<label htmlFor="official" className="davron-label">
					<img src={official} alt="Official translation logo" />
					{i18n.t('services.official_translation', {lng})}
					</label>
					</div>
				</div>
				<div className="col-6 col-md-3 form-input">
				<div className="radio-button">
					<Field
						name="service"
						id="interpreting"
						type="radio"
						component="input"
						value="interpreting"
						onClick={props.onClick}
					/>
					<label htmlFor="interpreting" className="davron-label">
					<img src={interpreting} alt="interpreting-logo" />
					{i18n.t('services.interpreting', {lng})}
					</label>
					</div>
				</div>
				<div className="col-6 col-md-3 form-input">
				<div className="radio-button">
					<Field
						name="service"
						id="coaching"
						type="radio"
						component="input"
						value="coaching"
						onClick={props.onClick}
					/>
					<label htmlFor="coaching" className="davron-label">
					<img src={coaching} alt="coaching-logo" />
					{i18n.t('services.coaching', {lng})}
					</label>
					</div>
				</div>
				
			</div>
		</div>
	)
  }


  export default DavronFormRequestType


// WEBPACK FOOTER //
// ./src/components/common/services.js